// Map providers: OpenFreeMap vector (MapLibre) everywhere WebGL works; Esri static basemap tiles as raster fallback (key-gated).
export const VECTOR_STYLE = "https://tiles.openfreemap.org/styles/liberty";
export const ESRI_KEY = process.env.REACT_APP_ESRI_API_KEY || "";
export const ESRI_TILES = ESRI_KEY ? `https://static-map-tiles-api.arcgis.com/arcgis/rest/services/static-basemap-tiles-service/v1/arcgis/streets/static/tile/{z}/{y}/{x}?token=${ESRI_KEY}` : "";
export const ESRI_ATTRIBUTION = 'Powered by <a href="https://www.esri.com/" target="_blank" rel="noreferrer">Esri</a> — Esri, TomTom, Garmin, FAO, NOAA, USGS, © OpenStreetMap contributors, and the GIS User Community';

/* Test seam: sessionStorage["dropit-map-test-block"] = substring; matching map resources are sent to an unreachable host.
   Lets automated tests fail worker-fetched tiles/glyphs in engines where request interception can't reach workers. */
export const transformRequest = (url, type) => {
  let block = null;
  try { block = sessionStorage.getItem("dropit-map-test-block"); } catch { /* ignore */ }
  if (block && url.includes(block)) return { url: url.replace(/^https:\/\/[^/]+/, "https://blocked.invalid") };
  return type === "Style" ? { url, cache: "default" } : undefined;
};

export const hasWebGL2 = () => {
  try { return !!document.createElement("canvas").getContext("webgl2", { failIfMajorPerformanceCaveat: false }); } catch { return false; }
};
export const isBrave = () => !!navigator.brave;

export const navLinks = (lat, lng) => ({
  apple: `https://maps.apple.com/?daddr=${lat},${lng}`,
  google: `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`,
  waze: `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`,
});
